import { ref, reactive, computed, onMounted } from 'vue'
import { defineStore } from 'pinia'

import Settings from '@model/settings'

export const useSettings = defineStore('settings', () => {
    const state = reactive({})

    const settings = ref(prebook_admin.settings || {})

    // Fetch Settings
    const fetchSettings = async (section = null) => {
        const response = await Settings.init().get({ section })
        if (section == null) {
            settings.value = response
        }
        Log('SETTINGS', response)
        // const response = await Settings.init().all() ||[]
        // console.log('response', response)
        return response
    }

    // Getters.
    const getSettings = computed(() => {
        return settings.value
    })

    // General Settings.
    const general = computed(() => {
        return settings.value.general || {}
    })

    // Business Settings.
    const business = computed(() => {
        return settings.value.business || {}
    })

    // Working Hours Settings.
    const businessHours = computed(() => {
        return settings.value.business_hours || {}
    })

    // Working Hours Settings.
    const daysOff = computed(() => {
        return settings.value.days_off || {}
    })

    // Payment Settings.
    const payment = computed(() => {
        return settings.value.payment || {}
    })
    // Update Settings.
    const saveSettings = async (section = 'general', options = null) => {

        let payload = settings.value

        if (options) {
            payload = {
                [section]: options
            }
        } else {
            payload = settings.value
        }

        state.isSaving = true


        const response = await Settings.init().update(payload)

        // Merge settings with payload.
        prebook_admin.settings = {
            ...prebook_admin.settings,
            ...payload
        }

        state.isSaving = false

        return response.success
    }

    const isSaving = computed(() => state.isSaving)


    const options = prebook_admin.options || {}

    const customizer = ref(prebook_admin.settings.customizer || {})

    const addons = computed(() => prebook_admin.settings.addons || {})

    const labels = computed(() => prebook_admin.settings.labels || {})

    const isRTL = computed(() => {
        return prebook_admin.is_rtl || false
    })

    // Return.
    return {
        settings,
        getSettings,
        general,
        business,
        businessHours,
        payment,
        fetchSettings,
        saveSettings,
        isSaving,
        options,
        daysOff,
        customizer,
        addons,
        labels,
        isRTL,
    }

})
